import { useState, useEffect } from 'react';

/**
 * Devuelve { height, offsetTop } del Visual Viewport.
 *
 * En iOS PWA, cuando el teclado abre, el browser puede hacer scroll del
 * layout viewport. visualViewport.offsetTop refleja ese desplazamiento.
 * Usamos offsetTop para compensar el top de los popups fixed y evitar
 * el gap vacío entre el campo enfocado y el teclado.
 */
export default function useVisualViewport() {
  const [state, setState] = useState({
    height: window.visualViewport?.height || window.innerHeight,
    offsetTop: window.visualViewport?.offsetTop || 0,
  });

  useEffect(() => {
    const vv = window.visualViewport;
    if (!vv) return;
    const handler = () => setState({ height: vv.height, offsetTop: vv.offsetTop });
    vv.addEventListener('resize', handler);
    vv.addEventListener('scroll', handler);
    return () => {
      vv.removeEventListener('resize', handler);
      vv.removeEventListener('scroll', handler);
    };
  }, []);

  return state;
}
